<template>
  <div class="text-center mt-lg-5">
    <i class="ti ti-4x ti-fw ti-refresh ti-spin" />
  </div>
</template>

<script>
  export default {
    name: 'QrcodeRedirectComponent',
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
      };
    },
    async mounted() {
      const identifier = this.$route.params.id;
      await this.$ajax.get(`api/public/qr/${identifier}`).then((uniqueKey) => {
        this.$router.push({ name: 'memorial.show', params: { id: uniqueKey } });
      }).catch(() => {
        this.$notify({
          title: this.$t('flashes.qr.error'),
          text: this.$t('flashes.qr.invalid'),
          type: 'error',
        });
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/QrcodeRedirect.vue